import { OccasionPage } from "@/components/public/OccasionPage"
import labelSchool from "@/images/label-school.webp"

const DESCRIPTION =
  "Personalised wine bottles for milestone birthdays, anniversaries and private celebrations: South African wine labelled for your occasion, UK-wide."

export default function PrivateEvents() {
  return (
    <OccasionPage
      title="Private Events"
      metaTitle="Personalised Wine for Private Events"
      description={DESCRIPTION}
      lede="Milestone birthdays, anniversaries and celebrations marked with a bottle made for the moment."
      heroImage={{
        src: labelSchool,
        alt: "Bespoke commemorative wine label for a private celebration",
        width: 941,
        height: 1672,
      }}
      story={{
        eyebrow: "Private Events",
        heading: "For the occasions worth marking",
        paragraphs: [
          "A milestone birthday, an anniversary, a family celebration — some occasions deserve more than a bottle bought off a shelf on the way over. A personalised label turns the wine itself into part of the memory.",
          "We have made bottles for foundation dinners and private celebrations alike; whatever the occasion, the label is designed around it and approved by you before anything is printed.",
        ],
      }}
      cellar={{
        lede: "A small selection of bespoke bottles produced for clubs, schools and clubhouses across the United Kingdom.",
        bottles: [
          {
            src: labelSchool,
            alt: "School foundation commemorative bottle",
            name: "Foundation Dinner",
            place: "Surrey",
          },
        ],
      }}
    />
  )
}
